export const MEETING_INVITATION_STATE_CHANGED =
  "waivera:meeting-invitation-state-changed";

export interface MeetingInvitationStateChangedDetail {
  notificationId?: string;
  status?: "Accepted" | "Declined";
}

export const dispatchMeetingInvitationStateChanged = (
  detail: MeetingInvitationStateChangedDetail = {},
) => {
  if (typeof window === "undefined") return;

  window.dispatchEvent(
    new CustomEvent<MeetingInvitationStateChangedDetail>(
      MEETING_INVITATION_STATE_CHANGED,
      { detail },
    ),
  );
};
